import { FILE_DOWNLOAD_PAGES, REPORTS_PAGES } from './constants';
import UserRegistrations from './components/Pages/Reports/UserRegistrations';
import UserLogins from './components/Pages/Reports/UserLogins';
import UserCourses from './components/Pages/Reports/UserCourses';
import UserCoursesAggregate from './components/Pages/Reports/UserCoursesAggregate';
import UserCheckupsAggregate from './components/Pages/Reports/UserCheckupsAggregate';
import UserAnswers from './components/Pages/Reports/UserAnswers';
import UserResources from './components/Pages/Reports/UserResources';
import UserCheckups from './components/Pages/Reports/UserCheckups';
import UserMeditations from './components/Pages/Reports/UserMeditations';
import UserCallsToAction from './components/Pages/Reports/UserCallsToAction';
import UserCallsToActionAggregate from './components/Pages/Reports/UserCallsToActionAggregate';
import UserSearches from './components/Pages/Reports/UserSearches';
import UserStressChange from './components/Pages/Reports/UserStressChange';
import UserStressAggregate from './components/Pages/Reports/UserStressAggregate';
import UserGamificationAggregate from './components/Pages/Reports/UserGamificationAggregate';
import UserFinancialWellnessChange from './components/Pages/Reports/UserFinancialWellnessChange';
import UserFeedback from './components/Pages/Reports/UserFeedback';
import UserSproutsEarned from './components/Pages/Reports/UserSproutsEarned';
import UserCreditEnrollment from './components/Pages/Reports/UserCreditEnrollment';
import UserCreditAggregate from './components/Pages/Reports/UserCreditAggregate';
import UserXp from './components/Pages/Reports/UserXp';
import UserJournals from './components/Pages/Reports/UserJournals';
import UserMoneyMindfulness from './components/Pages/Reports/UserMoneyMindfulness';
import UserMindfulnessAggregate from './components/Pages/Reports/UserMindfulnessAggregate';
import UserAiConversations from './components/Pages/Reports/UserAiConversations';
import UserAiAggregate from './components/Pages/Reports/UserAiAggregate';
import UserMoneyPersonality from './components/Pages/Reports/UserMoneyPersonality';
import UserMoneyPersonalityAggregate from './components/Pages/Reports/UserMoneyPersonalityAggregate';
import UserReportCard from './components/Pages/Reports/UserReportCard/UserReportCard';
import UserSproutsRedeemed from './components/Pages/Reports/UserSproutsRedeemed';
import Dashboard from './components/Pages/Reports/Dashboard';
import UserIngressAggregate from './components/Pages/Reports/UserIngressAggregate';
import UsageSummary from './components/Pages/Reports/UsageSummary';
import CounselingReports from './components/Pages/Reports/CounselingReports/CounselingReports';

// Simple lookup from report page slugs to React components
export const reportComponentLink = {
    [REPORTS_PAGES.dashboard]: Dashboard,
    [REPORTS_PAGES.userRegistrations]: UserRegistrations,
    [REPORTS_PAGES.userLogins]: UserLogins,
    [REPORTS_PAGES.userCourses]: UserCourses,
    [REPORTS_PAGES.userCoursesAggregate]: UserCoursesAggregate,
    [REPORTS_PAGES.userIngressAggregate]: UserIngressAggregate,
    [REPORTS_PAGES.userAnswers]: UserAnswers,
    [REPORTS_PAGES.userResources]: UserResources,
    [REPORTS_PAGES.userCheckups]: UserCheckups,
    [REPORTS_PAGES.userCheckupsAggregate]: UserCheckupsAggregate,
    [REPORTS_PAGES.userMeditations]: UserMeditations,
    [REPORTS_PAGES.userCallsToAction]: UserCallsToAction,
    [REPORTS_PAGES.userCallsToActionAggregate]: UserCallsToActionAggregate,
    [REPORTS_PAGES.userSearches]: UserSearches,
    [REPORTS_PAGES.userStressChange]: UserStressChange,
    [REPORTS_PAGES.userStressAggregate]: UserStressAggregate,
    [REPORTS_PAGES.userGamificationAggregate]: UserGamificationAggregate,
    [REPORTS_PAGES.userFinancialWellnessChange]: UserFinancialWellnessChange,
    [REPORTS_PAGES.userFeedback]: UserFeedback,
    [REPORTS_PAGES.userSproutsEarned]: UserSproutsEarned,
    [REPORTS_PAGES.userSproutsRedeemed]: UserSproutsRedeemed,
    [REPORTS_PAGES.userCreditEnrollment]: UserCreditEnrollment,
    [REPORTS_PAGES.userCreditAggregate]: UserCreditAggregate,
    [REPORTS_PAGES.userXp]: UserXp,
    [REPORTS_PAGES.userJournals]: UserJournals,
    [REPORTS_PAGES.userMoneyMindfulness]: UserMoneyMindfulness,
    [REPORTS_PAGES.userMindfulnessAggregate]: UserMindfulnessAggregate,
    [REPORTS_PAGES.userAiConversations]: UserAiConversations,
    [REPORTS_PAGES.userAiAggregate]: UserAiAggregate,
    [REPORTS_PAGES.userMoneyPersonality]: UserMoneyPersonality,
    [REPORTS_PAGES.userMoneyPersonalityAggregate]: UserMoneyPersonalityAggregate,
    [REPORTS_PAGES.userReportCard]: UserReportCard,
    [REPORTS_PAGES.usageSummary]: UsageSummary,
};

// Simple lookup from file download page slugs to React components
export const fileDownloadComponentLink = {
    [FILE_DOWNLOAD_PAGES.counselingReports]: CounselingReports,
};
